/* eslint-disable no-console */
import { AxiosError } from 'axios';
import {
  fetchBasicFr,
  fetchCheckAuth,
  fetchPraviteDb,
} from 'components/libs/fetch';
import { API_PATHS } from 'constant/api';

import { TABLE_PAGE_INIT, TABLE_PAGE_SIZE } from './constant';

const postLogin = async ({
  body: _body,
}: {
  body: {
    username: string;
    password: string;
  };
}): Promise<boolean> => {
  try {
    return Promise.resolve(true);
  } catch (error) {
    return Promise.reject(false);
  }
};

const getUser = async (_accessToken?: string): Promise<object> => {
  try {
    return Promise.resolve({ name: 'TARO' });
  } catch (error) {
    return Promise.reject(error);
  }
};

const postAuthLogin = async (header: IHeader) => {
  const api = fetchCheckAuth(
    header.appId,
    header.appKey,
    header.dbId,
    header.dbKey
  );

  try {
    const params = new URLSearchParams({
      page: '1',
      take: '1',
    }).toString();
    const { data } = await api.get(API_PATHS.face_id + '?' + params);
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};

const getDatabases = async (body: IGetDatabaseQuery) => {
  const api = fetchBasicFr({ appId: body.appId, appKey: body.appKey });
  const { ...query } = body;

  const searchQuery: Record<string, string> = {
    'pagination[page]': query.page ?? TABLE_PAGE_INIT,
    'pagination[pageSize]': query.pageSize ?? TABLE_PAGE_SIZE,
  };
  if (query.name) searchQuery['filters[name]'] = query.name;
  const params = new URLSearchParams(searchQuery).toString();

  try {
    const { data } = await api.get(API_PATHS.database(body.id) + '?' + params);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const createUser = async (form: FormData, header: IHeader) => {
  const api = fetchPraviteDb(
    header.appId,
    header.appKey,
    header.dbId,
    header.dbKey
  );

  try {
    const { data } = await api.post(API_PATHS.face_id, form, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return data;
  } catch (error) {
    console.log(error);
    return Promise.reject(error);
  }
};

const getUsers = async (body: IGetUsersQuery, header: IHeader) => {
  const api = fetchPraviteDb(
    header.appId,
    header.appKey,
    header.dbId,
    header.dbKey
  );
  const { ...query } = body;

  const searchQuery: Record<string, string> = {
    page: query.page ?? TABLE_PAGE_INIT,
    pageSize: query.pageSize ?? TABLE_PAGE_SIZE,
  };
  if (query.displayName)
    searchQuery['filters[displayName]'] = query.displayName;
  if (query.affiliation)
    searchQuery['filters[affiliation]'] = query.affiliation;
  if (query.tag) searchQuery['filters[tag]'] = query.tag;
  const params = new URLSearchParams(searchQuery).toString();

  try {
    const { data } = await api.get(API_PATHS.face_id + '?' + params);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const getUserDetail = async (id: string, header: IHeader) => {
  const api = fetchPraviteDb(
    header.appId,
    header.appKey,
    header.dbId,
    header.dbKey
  );

  try {
    const result = await api.get(API_PATHS.face_id_detail(id));
    return result.data;
  } catch (error) {
    console.log(error);
  }
};

const updateUser = async (
  id: string,
  form: FormData,
  header: IHeader,
  formAvartar?: FormData
) => {
  const api = fetchPraviteDb(
    header.appId,
    header.appKey,
    header.dbId,
    header.dbKey
  );

  try {
    if (formAvartar?.has('avatar')) {
      await api.patch(API_PATHS.get_avatar_image(id), formAvartar, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    }

    const { data } = await api.put(API_PATHS.face_id_detail(id), form, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return data;
  } catch (error) {
    console.log(error);
    return Promise.reject(error);
  }
};

const deleteUser = async (id: string, header: IHeader) => {
  const api = fetchPraviteDb(
    header.appId,
    header.appKey,
    header.dbId,
    header.dbKey
  );

  try {
    const { data } = await api.delete(API_PATHS.face_id_detail(id));
    return data;
  } catch (error) {
    console.log(error);
  }
};

const searchFaceId = async (
  header: IHeader,
  file: File,
  isUpdate?: boolean,
  idRef?: string
) => {
  const baseCore = 0.9;
  const api = fetchPraviteDb(
    header.appId,
    header.appKey,
    header.dbId,
    header.dbKey
  );
  const formData = new FormData();
  formData.append('image', file);
  if (isUpdate && idRef) {
    formData.append(
      'data',
      JSON.stringify({ isUpdate: true, idReference: idRef })
    );
  }

  try {
    if (isUpdate && idRef) {
      const result = await api.post(
        API_PATHS.search_verify_image(idRef),
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      const data = result.data as IFaceIdVerifyResponse;

      const core = data?.similarity ?? 0;

      return core >= baseCore;
    } else {
      try {
        const result = await api.post(API_PATHS.face_id_search, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        const data = result.data as IFaceIdSearchResponse;
        const core = data?.score ?? 0;
        return core < baseCore;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } catch (ex: any) {
        if (ex?.response?.status === 404) {
          return isUpdate ? false : true;
        }
        throw ex;
      }
    }
  } catch (error) {
    console.log(error);
    return Promise.reject(error);
  }
};
export interface ISystemErrorResponse {
  response_message?: string;
  response_code?: string;
}

export type FetchErrorData = AxiosError<ISystemErrorResponse>;

export {
  createUser,
  deleteUser,
  getDatabases,
  getUser,
  getUserDetail,
  getUsers,
  postAuthLogin,
  postLogin,
  searchFaceId,
  updateUser,
};
